import { openDB } from 'idb';
import { OfflineConstants } from './constants';

const getDb = async () => {
    // Increment the version number to trigger an upgrade event
    const db = await openDB('OrcaWebOfflineDB', OfflineConstants.versionNumber, {
        upgrade(db) {
            const storeNames = Object.values(OfflineConstants.stores).map((store) => store.storeName);

            storeNames.forEach((storeName) => {
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName, { autoIncrement: false });
                }
            });
        },
    });

    return db;
};

export const initStores = async () => {
    const db = await getDb();
    db.close();
};

export const getStoreItem = async (storeName, key) => {
    const db = await getDb();
    const item = await db.get(storeName, key);
    db.close();
    return item;
};

export const getAllStoreItems = async (storeName) => {
    const db = await getDb();
    const items = await db.getAll(storeName);
    db.close();
    return items;
};

export const putStoreItem = async (storeName, storeItem, key) => {
    storeItem.lastUpdated = Date.now();
    const db = await getDb();
    await db.put(storeName, storeItem, key);
    db.close();
};

export const deleteStoreItem = async (storeName, key) => {
    const db = await getDb();
    await db.delete(storeName, key);
    db.close();
};

export const getDbMetaDataForSync = async () => {
    const db = await getDb();
    const storeNames = Object.values(OfflineConstants.stores).reduce((acc, store) => {
        if (!store.excludeFromSync) {
            acc.push(store.storeName);
        }
        return acc;
    }, []);
    const storeCounts = Object.fromEntries(await Promise.all(storeNames.map(async (storeName) => [storeName, await db.count(storeName)])));
    db.close();

    return {
        storeCounts: storeNames.reduce((acc, storeName) => {
            acc[storeName] = storeCounts[storeName];
            return acc;
        }, {}),
        itemCount: Object.values(storeCounts).reduce((sum, count) => sum + count, 0),
    };
};

export const getStoreKeys = async (storeName) => {
    const db = await getDb();
    const keys = await db.getAllKeys(storeName);
    db.close();
    return keys;
};
